import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from '../../global';
import { RootState } from '../../store';
import { languagesSelectors } from './languages.state';
import { Language } from './languages.types';

export const useLanguagesState = (): RootState['languages'] => {
  const languages = useSelector<RootState, RootState['languages']>(state => state.languages);

  useDebugValue(languages);

  return languages;
};

export const useLanguagesValues = (): Language[] => {
  const languages = useSelector<RootState, RootState['languages']>(state => state.languages);

  const result = languagesSelectors.selectAll(languages);

  useDebugValue(result);

  return result;
};

export const useLanguageByCode = (code: string): AsyncEntity<Language> | null => {
  const languages = useSelector<RootState, RootState['languages']>(state => state.languages);

  const result = languagesSelectors.selectById(languages, code) || null;

  useDebugValue(result);

  return result;
};
